import { FormControlLabel, type SxProps, type Theme } from "@mui/material";
import { styled } from "@mui/material/styles";

import { Box } from "ui/box/box";
import { SWITCH_LABEL_GAP, SWITCH_LABEL_VARIANT } from "ui/switch/switch.constants";
import { type SwitchProps } from "ui/switch/switch.types";

export const SwitchRoot = styled(Box)({
  display: "inline-flex",
  alignItems: "center",
});

/**
 * `sx` shorthands do NOT work inside `styled()` — no `styleFunctionSx` pass. `gap: 0.75` would be
 * `0.75px`, `typography: "body2"` would be dropped, `color: "grey.400"` would be `canvastext`.
 * Nothing warns; only the switch tests catch it. Keep every value an explicit `theme.*` lookup.
 *
 * The disabled label colour is MUI's own, `text.disabled`, which is Figma's value.
 */
export const SwitchLabel = styled(FormControlLabel)(({ theme }) => ({
  marginLeft: 0,
  marginRight: 0,
  gap: theme.spacing(SWITCH_LABEL_GAP),
  color: theme.palette.text.primary,

  "& .MuiFormControlLabel-label": {
    ...theme.typography[SWITCH_LABEL_VARIANT],
  },
}));

export const getLabelSx = (labelSx: SwitchProps["labelSx"]): SxProps<Theme> | undefined =>
  labelSx ? { "& .MuiFormControlLabel-label": labelSx } : undefined;
